import styled from 'styled-components';

const Container = styled.section`
  padding: 40px 0;

  &:first-child {
    padding-top: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.global.borderColor};
  }
`;

const Title = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Content = styled.div<{ $maxWidth?: number }>`
  max-width: ${(props) => (props.$maxWidth ? `${props.$maxWidth}px` : 'initial')};
`;

interface SectionProps {
  title?: string;
  maxWidth?: number;
  children?: React.ReactNode;
}

const Section = ({ title, maxWidth, children }: SectionProps) => {
  return (
    <Container>
      {title && <Title>{title}</Title>}
      <Content $maxWidth={maxWidth}>{children}</Content>
    </Container>
  );
};

export default Section;
